import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import IExistingPaymentMethod from '@sunbit-dev/common/models/cardApply/IExistingPaymentMethod';
import IApplicationError from '@sunbit-dev/common/models/IApplicationError';
import { Actions } from '../actions/identificationActions';
import { ActionTypes } from '../models/actions/identification';

export interface IExistingPaymentMethodsState {
  type?: ActionTypes;
  status?: ActionStatus;
  existingPaymentMethods: IExistingPaymentMethod,
  error?: IApplicationError;
}

const initialState: IExistingPaymentMethodsState = {
  existingPaymentMethods :{
    paymentProfiles : [],
    isMla : false,
  },

};

export default function existingPaymentMethodsReducer(
  state = initialState,
  action: Actions
): IExistingPaymentMethodsState {
  switch (action.type) {
    case ActionTypes.getExistingPaymentMethods:
      return { ...state, ...action };
    default:
      return state;
  }
}
